import React, { useEffect, useRef, useState } from "react";
import { api, imgUrl } from "@/lib/api";
import { Pause, Play, X } from "lucide-react";

export default function AnthemPlayer() {
  const [s, setS] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);
  const audioRef = useRef();

  useEffect(() => { api.get("/settings").then(({ data }) => setS(data)).catch(() => {}); }, []);

  if (!s || !s.anthem_url) return null;
  const url = imgUrl(s.anthem_url);
  const isVideo = s.anthem_type === "video";

  const toggle = () => {
    if (isVideo) { setOpenVideo(true); return; }
    const a = audioRef.current;
    if (playing) { a.pause(); setPlaying(false); } else { a.play(); setPlaying(true); }
  };

  return (
    <>
      <button onClick={toggle} data-testid="anthem-float-btn"
        className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[55] bg-[#1F4D2E] rounded-full p-1.5 sm:pl-3 sm:pr-5 sm:py-2.5 shadow-[0_10px_30px_rgba(0,0,0,0.28)] flex items-center gap-2.5 hover:bg-[#153c22] transition-colors">
        <span className={`w-9 h-9 rounded-full bg-[#E0A526] text-[#1F4D2E] flex items-center justify-center ${playing ? "animate-pulse" : ""}`}>
          {playing ? <Pause size={17} /> : <Play size={17} className="ml-0.5" />}
        </span>
        <span className="hidden sm:inline text-sm font-semibold text-white">{playing ? "Playing anthem" : "Play anthem"}</span>
      </button>

      {!isVideo && <audio ref={audioRef} src={url} onEnded={() => setPlaying(false)} />}

      {isVideo && openVideo && (
        <div className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4" onClick={() => setOpenVideo(false)} data-testid="anthem-video-modal">
          <button className="absolute top-5 right-5 text-white/80 hover:text-white" onClick={() => setOpenVideo(false)} data-testid="anthem-video-close"><X size={30} /></button>
          <video src={url} controls autoPlay className="max-h-[85vh] max-w-full w-auto rounded-lg object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
}
